module.exports = __webpack_public_path__ + "static/img/1.efadd39.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/Main/1.png
// module id = 267
// module chunks = 18